// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1L4-z","label":"LabeledBox_label__1hekw"};